import React, { useState } from "react";
const backendUrl = process.env.REACT_APP_BACKEND_API_URL_LOCAL;

const BulletinEntry = () => {
  const [entries, setEntries] = useState([
    { dateTime: "", longitude: "", latitude: "", observedForecast: "Forecast", category: "category1", windSpeed: "" }
  ]);

  const [formData, setFormData] = useState({
    cycloneName: "",
    date: "",
    bulletin: "",
    maxWinds: "",
    cycloneSpeed: "",
    title: "",
    observation: "",
  });

  const handleAddEntry = () => {
    setEntries([...entries, { dateTime: "", longitude: "", latitude: "", observedForecast: "Forecast", category: "category1", windSpeed: "" }]);
  };

  const handleRemoveEntry = (index) => {
    const newEntries = entries.filter((_, i) => i !== index);
    setEntries(newEntries);
  };

  const handleInputChange = (index, field, value) => {
    const newEntries = [...entries];
    newEntries[index][field] = value;
    setEntries(newEntries);
  };

  const handleFormChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const handleSubmit = async () => {
    const observedData = entries
      .filter(entry => entry.observedForecast === "Observed")
      .map(({ dateTime, longitude, latitude, category, windSpeed }) => ({
        date_time: dateTime,
        longitude: parseFloat(longitude),
        latitude: parseFloat(latitude),
        category,
        wind_speed: parseInt(windSpeed),
      }));
  
    const forecastData = entries
      .filter(entry => entry.observedForecast === "Forecast")
      .map(({ dateTime, longitude, latitude, category, windSpeed }) => ({
        date_time: dateTime,
        longitude: parseFloat(longitude),
        latitude: parseFloat(latitude),
        category,
        wind_speed: parseInt(windSpeed),
      }));
  
    const fullData = {
      cyclone_name: formData.cycloneName,
      date: formData.date,
      bulletin: formData.bulletin,
      max_winds: formData.maxWinds,
      cyclone_speed: formData.cycloneSpeed,
      title: formData.title,
      observation: formData.observation,
      observed_data: observedData,
      forecast_data: forecastData,
    };
  
    try {
      const response = await 
              // fetch("http://127.0.0.1:8000/cyclone/cyclone-track/", 
      fetch(`${backendUrl}cyclone/cyclone-track/`, 
        
        {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(fullData),
      });
  
      if (response.ok) {
        alert("Data submitted successfully!");
      } else {
        alert("Error submitting data");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Failed to connect to the server");
    }
  };

  return (
    <div className="container mt-4">
      
      {/* Main Form */}
      <div className="row">
        <div className="col-md-4">
          <label><strong>Name of the Cyclone</strong></label>
          <input type="text" className="form-control" value={formData.cycloneName} onChange={(e) => handleFormChange("cycloneName", e.target.value)} />
        </div>
        <div className="col-md-4">
          <label><strong>Date</strong></label>
          <input type="date" className="form-control" value={formData.date} onChange={(e) => handleFormChange("date", e.target.value)} />
        </div>
        <div className="col-md-4">
          <label><strong>Bulletin</strong></label>
          <input type="text" className="form-control" value={formData.bulletin} onChange={(e) => handleFormChange("bulletin", e.target.value)} />
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-md-4">
          <label><strong>Maximum Winds (Kmph)</strong></label>
          <input type="number" className="form-control" value={formData.maxWinds} onChange={(e) => handleFormChange("maxWinds", e.target.value)} />
        </div>
        {/* <div className="col-md-4">
          <label><strong>Cyclone Speed for past 6 hours</strong></label>
          <input type="number" className="form-control" value={formData.cycloneSpeed} onChange={(e) => handleFormChange("cycloneSpeed", e.target.value)} />
        </div> */}
        {/* <div className="col-md-4">
          <label><strong>Title</strong></label>
          <input type="text" className="form-control" value={formData.title} onChange={(e) => handleFormChange("title", e.target.value)} />
        </div> */}
      </div>

      <div className="row mt-3">
        {/* <div className="col-md-12">
          <label><strong>Observation</strong></label>
          <textarea className="form-control" rows="3" value={formData.observation} onChange={(e) => handleFormChange("observation", e.target.value)}></textarea>
        </div> */}
      </div>

      <p className="mt-3 text-muted">e.g., Longitude - 125.5603, Latitude -8.5535</p>

      {/* Table for Data Entries */}
      <table className="table table-bordered mt-3">
        <thead>
          <tr>
            <th>Date/Time</th>
            <th>Longitude</th>
            <th>Latitude</th>
            <th>Observed/Forecast</th>
            <th>Category</th>
            <th>Wind Speed</th>
            <th>Gust</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {entries.map((entry, index) => (
            <tr key={index}>
              <td>
                <input type="datetime-local" className="form-control"
                  value={entry.dateTime}
                  onChange={(e) => handleInputChange(index, "dateTime", e.target.value)} />
              </td>
              <td>
                <input type="text" className="form-control"
                  value={entry.longitude}
                  onChange={(e) => handleInputChange(index, "longitude", e.target.value)} />
              </td>
              <td>
                <input type="text" className="form-control"
                  value={entry.latitude}
                  onChange={(e) => handleInputChange(index, "latitude", e.target.value)} />
              </td>
              <td>
                <select className="form-control"
                  value={entry.observedForecast}
                  onChange={(e) => handleInputChange(index, "observedForecast", e.target.value)}>
                  <option value="Forecast">Forecast</option>
                  <option value="Observed">Observed</option>
                </select>
              </td>
              <td>
                <select className="form-control"
                  value={entry.category}
                  onChange={(e) => handleInputChange(index, "category", e.target.value)}>
                  <option value="category1">category1</option>
                  <option value="category2">category2</option>
                  <option value="category3">category3</option>
                  {/* <option value="Cyclonic Storm">Cyclonic Storm</option>
                  <option value="Severe Cyclonic Storm">Severe Cyclonic Storm</option>
                  <option value="Very Severe Cyclonic Storm">Very Severe Cyclonic Storm</option>
                  <option value="Extreme Severe Cyclonic Storm">Extreme Severe Cyclonic Storm</option>
                  <option value="Super Cyclonic Storm">Super Cyclonic Storm</option> */}
                </select>
              </td>
              <td>
                <input type="number" className="form-control"
                  value={entry.windSpeed}
                  onChange={(e) => handleInputChange(index, "windSpeed", e.target.value)} />
              </td>
              <td>
                <input type="number" className="form-control"
                  value={entry.gust}
                  onChange={(e) => handleInputChange(index, "gust", e.target.value)} />
              </td>
              <td>
                {index !== 0 && (
                  <button className="btn btn-danger btn-sm" onClick={() => handleRemoveEntry(index)}>Remove</button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Buttons */}
      <div className="d-flex justify-content-between">
        <button className="btn btn-primary" onClick={handleAddEntry}>Add More</button>
        <button className="btn btn-success" onClick={handleSubmit}>Submit</button>
      </div>
    </div>
  );
};

export default BulletinEntry;
